import * as React from 'react';
import * as I18n from 'i18n-js';
import HideableSlider from './hideable_slider';
import BumpBarGraphic from './bump_bar_graphic';
import BumpBidSlider, { Props as BumpBidSliderProps } from './bump_bid_slider';

function BumpGraphic() {
  return (
    <div>
      <h4 className="product-bump__slider-col__label">{I18n.t('discovery.bump.change.adjustRate')}</h4>
      <div className="product-bump__views-scale">
        <div className="product-bump__scale-img">
          <div className="product-bump__scale-img__inner">
            <BumpBarGraphic
              highlightStartPercentage={50}
              highlightEndPercentage={80}
            />
          </div>
        </div>
        <div className="product-bump__views-scale__more">{I18n.t('discovery.bump.setup.moreViews')}</div>
        <div className="product-bump__views-scale__most-popular product-bump__views-scale__most-popular--new">
          {I18n.t('discovery.bump.setup.recommendedTiers')}
        </div>
        <div className="product-bump__views-scale__much-more">{I18n.t('discovery.bump.setup.manyMoreViews')}</div>
      </div>
    </div>
  );
}

interface BumpChangeProps {
  bumpBidSliderProps: BumpBidSliderProps;
  impressions?: number;
  salesCount?: number;
  salesSpent?: string;
  salesRevenue?: string;
  showMobileSlider?: boolean;
  sliderToggle?: Function;
  currentBid?: number;
  hasInventory?: boolean;
}

function BumpChange(props: BumpChangeProps) {
  return (
    <div className="product-bump__wrapper">
      <div className="product-bump__overview-col">
        <h4 className="product-bump__overview-col__stat-heading">{I18n.t('discovery.bump.change.performance')}</h4>
        <ul className="product-bump__overview-col__stats">
          <li>
            <div className="product-bump__overview-col__stats__stat">
              {props.impressions}
            </div>
            <div className="product-bump__overview-col__stats__label">
              {I18n.t('discovery.bump.change.impressions')}
            </div>
          </li>
          {props.hasInventory &&
            <li>
              <div className="product-bump__overview-col__stats__stat">
                {props.salesCount}
              </div>
              <div className="product-bump__overview-col__stats__label">
                {I18n.t('discovery.bump.change.numberSold')}
              </div>
            </li>
          }
          <li>
            <div
              className="product-bump__overview-col__stats__stat"
              dangerouslySetInnerHTML={{ __html: props.salesSpent }}
            />
            <div className="product-bump__overview-col__stats__label">
              {I18n.t('discovery.bump.change.spent')}
            </div>
          </li>
          <li>
            <div
              className="product-bump__overview-col__stats__stat"
              dangerouslySetInnerHTML={{ __html: props.salesRevenue }}
            />
            <div className="product-bump__overview-col__stats__label">
              {I18n.t('discovery.bump.change.sales')}
            </div>
          </li>
        </ul>
      </div>
      <div className="product-bump__slider-col">
        <HideableSlider
          label={I18n.t('discovery.bump.change.adjustRate')}
          sliderToggle={props.sliderToggle}
          showMobileSlider={props.showMobileSlider}
          currentBid={props.currentBid}
        >
          <BumpGraphic />
          <BumpBidSlider {...props.bumpBidSliderProps} />
        </HideableSlider>
      </div>
    </div>
  );
}

export default BumpChange;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/bump_change.tsx